import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    ActionIcon,
    Button,
    Group,
    Tooltip,
} from '@mantine/core';

export default function DataTableCreate({
    newStoryLink, onRefresh,
}) {
    return (
        <Group spacing="xs">
            {newStoryLink && (
                <Button
                    variant="outline"
                    size="sm"
                    component="a"
                    target="__blank"
                    href={newStoryLink}
                    leftIcon={<FontAwesomeIcon icon="plus" />}
                >
                    Добавить
                </Button>
            )}
            <Tooltip label="Обновить список">
                <ActionIcon color="blue" variant="light" size="lg" onClick={onRefresh}>
                    <FontAwesomeIcon icon="sync" />
                </ActionIcon>
            </Tooltip>
        </Group>
    );
}
